import { gql } from '@apollo/client';

export const PAGED_LEASING_COMMISSIONS_QUERY = gql`
  query pagedLeasingCommissions($pager: PagerInputNew, $filters: LeasingCommissionFilterInput) {
    pagedLeasingCommissions(pager: $pager, filters: $filters) {
      total
      values {
        commissionId
        commissionCode
        commissionName
        commissionPercent
        commissionValue
        assignToRoleId
        assignToRole
        isReadOnly
        calcTypeId
        calcTypeName
        isSubsidy
        isCommission
      }
    }
  }
`;

export const LEASING_COMMISSION_ASSIGNED_TO_LIST = gql`
  query leasingCommissionAssignedToList {
    leasingCommissionAssignedToList {
      assignToRoleId
      assignToRole
    }
  }
`;
